import React, { useState } from 'react';
import BackHomeButton from '../components/BackHomeButton';

const videoList = [
  {
    title: 'Solve Login and Download Pop Up Blocker Issue',
    url: 'https://www.youtube.com/embed/pnRI0u79r7M'
  },
  {
    title: 'Disable Pop Up blocker for Worksheet Generation',
    url: 'https://www.youtube.com/embed/AyUlUmcx9UI'
  },
  {
    title: 'First Time Login and profile creation',
    url: 'https://www.youtube.com/embed/NqNHek8fjSI'
  },
  {
    title: 'How to use AI Quiz Tool',
    url: 'https://youtube.com/embed/3W6r_cz6htw'
  },
  {
    title: 'How to Use AI WorkSheet Generator',
    url: 'https://www.youtube.com/embed/GHnDpwuhKt4'
  },
    {
    title: 'How to Use AI Composition and Answer Checker',
    url: 'https://www.youtube.com/embed/vmzUoUDiudM'
  },
  {
    title: 'How to Use generate Worksheet in school format',
    url: 'https://www.youtube.com/embed/3fVxUBi-3jo'
  },
    {
    title: 'How to Use AI picture quiz',
    url: 'https://www.youtube.com/embed/m98akhSo4FU'
  },
  {
    title: 'How to Upload Your Worksheet',
    url: 'https://www.youtube.com/embed/zGIgTa4K2_E'
  },
  {
    title: 'How to Download Others Worksheet',
    url: 'https://www.youtube.com/embed/pu4CQnZiffs'
  },
  {
    title: 'How to use Dictation and Oral Lesson Creator Tool',
    url: 'https://www.youtube.com/embed/o6MIAVDIHwc'
  },
  {
    title: 'How to Request Worksheet from Admin',
    url: 'https://www.youtube.com/embed/sJQ_nJ3NlEs'
  },
  {
    title: 'How to Change Other Options in Tool',
    url: 'https://www.youtube.com/embed/W8l7UfSY5Bk'
  }
];

const Tutorials = () => {
  const [selectedVideo, setSelectedVideo] = useState(videoList[0].url);

  return (
    <div style={styles.container}>

        <BackHomeButton style={{ marginTop: '2rem' }} />

      <h2 style={styles.heading}>📽️ Eascode Tutorial Videos</h2>
      <div style={styles.card}>
        <label style={styles.label}>Choose a Tutorial:</label>
        <select
          onChange={(e) => setSelectedVideo(e.target.value)}
          style={styles.select}
        >
          {videoList.map((video, index) => (
            <option key={index} value={video.url}>
              {video.title}
            </option>
          ))}
        </select>

        <div style={styles.videoContainer}>
          <iframe
            width="100%"
            height="315"
            src={selectedVideo}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '2rem auto',
    fontFamily: 'Segoe UI, sans-serif'
  },
  heading: {
    textAlign: 'center',
    marginBottom: '1rem',
    color: '#333'
  },
  card: {
    backgroundColor: '#fff',
    padding: '1.5rem',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
  },
  label: {
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    display: 'block'
  },
  select: {
    width: '100%',
    padding: '0.6rem',
    fontSize: '1rem',
    borderRadius: '8px',
    marginBottom: '1.5rem'
  },
  videoContainer: {
    borderRadius: '8px',
    overflow: 'hidden'
  }
};

export default Tutorials;
